import { IGlobalPartnerState } from 'legacy/lut/features/globalPartner/models/iGlobalPartnerState'
import { IPartner360State } from 'legacy/lut/features/partner360/common/models'
import { IPartnerState } from 'legacy/lut/features/partner/models'
import { IPartnerDashboardState } from 'legacy/lut/features/partnerDashboard'

import { IAccessManagementState } from 'clickNgo/features/accessManagement/models'
import { IPartnerSearchState } from 'clickNgo/features/partnerSearchStore'
import { IWidgetEventState } from 'clickNgo/features/widgetEvent/models'
import { TWidgetState } from 'clickNgo/features/widgets/models'
import { IFormState } from 'cng-common/features/form/models'
import { IForm } from 'core-components/classes/models/IForm'
import { IState as ICoreState } from 'core/store'
import { IAppState } from 'core/store/state'
import Logger from 'core/utils/Logger'
import { IOnboardingState } from 'onboarding/features/models'
import { IExtendedPartnerDataState } from 'partner360/features/extendedPartnerData'
import { IMasterDealerDataState } from 'partner360/features/masterDealerData'
import { setApplicationStore as setSearchApplicationStore } from 'search/store'

import { lutReducer } from './reducer'
import { LOOKUP_NEXT_STATE } from './reducer'
import { ILookupForms, ILookupOldState, StoreForms } from './state'

interface ILegacyStoreHotData {
  applicationStore?: any
}

const hotData = import.meta.hot?.data as ILegacyStoreHotData | undefined

let store: any = hotData?.applicationStore

/**
 * @deprecated avoid usage of global store
 * */
export const appGetFullStateObject = () => store.getState()
/**
 * @deprecated avoid usage of global store
 * */
export const appGetState = (): IAppState => store.getState().app

/**
 * @deprecated avoid usage of global store
 * */
export const setApplicationStore = (applicationStore: any) => {
  setSearchApplicationStore(applicationStore)
  store = applicationStore

  if (import.meta.hot) {
    const data = import.meta.hot.data as ILegacyStoreHotData
    data.applicationStore = applicationStore
  }

  return store
}

/**
 * @deprecated avoid usage of global store
 * */
export const lookupGetState = (): ILookupForms => store.getState().lookup
/**
 * @deprecated avoid usage of global store
 * */
export const lookupGetStateOld = (): ILookupOldState => store.getState().lookupOld

/**
 * @deprecated avoid usage of global store
 * */
export const setNextLookupState = (state: any, comment?: string) => {
  store.dispatch({ state, comment, type: LOOKUP_NEXT_STATE })
}

export const save = (formId: string, query: string, data: { items: IForm[]; total: number }) => {
  store.dispatch({
    formId: StoreForms[formId],
    query,
    data,
    type: '@LOOKUP_SAVE',
    state: lookupGetState(),
  })
}

export const read = (formId: StoreForms, query: string) => {
  const store = lookupGetState()
  let res
  try {
    res = store.forms[formId].queries[query]
  } catch (e) {
    Logger.error('Lookup read error', e)
  }
  return res
}

export const remove = (formId: StoreForms, EntryId: number) => {
  store.dispatch({
    formId,
    EntryId,
    type: '@LOOKUP_REMOVE',
    state: lookupGetState(),
  })
}

export const storeApi = {
  read: async (fId: string, query: string) => {
    const res = await read(fId as StoreForms, query)
    return res
  },
  save: async (fId: string, query: string, data: { items: IForm[]; total: number }) => {
    await save(fId as StoreForms, query, data)
  },
  formId: StoreForms.partners,
}

export { lutReducer as reducer }

export interface IState extends ICoreState {
  widgets: TWidgetState
  masterDealerData: IMasterDealerDataState
  extendedPartnerData: IExtendedPartnerDataState
  widgetEvent: IWidgetEventState
  accessManagement: IAccessManagementState
  globalPartner: IGlobalPartnerState
  partnerDashboard: IPartnerDashboardState
  partner360: IPartner360State
  partnerSearch: IPartnerSearchState
  partner: IPartnerState
  onboarding: IOnboardingState
  form: IFormState
  lookup: ILookupForms
  lookupOld: ILookupOldState
}
